module.exports = __webpack_public_path__ + "img/l.5f622d73.jpg";